import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Divider, Space } from "antd";
import { LogoIcon } from "assets/icons";
import {
  SESSION_TYPE,
  STORAGE_KEYS,
  TWO_FACTOR_AUTH,
} from "constants/appConstant";
import { login, setEmail } from "stores/slices/auth";
import StorageHelper from "utils/storeHelper";

import LoginForm from "components/forms/loginForm";

import SocialLogin from "./socialLogin";

import styles from "./styles.module.scss";

const LoginPage = () => {
  const dispatch = useDispatch();

  const { t } = useTranslation();

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async values => {
    setLoading(true);
    const { payload } = await dispatch(login(values));

    if (payload && payload.status === 200) {
      const res = payload.data;
      if (res.sessionType === SESSION_TYPE.TWO_FA && res.verified) {
        StorageHelper.setCookie(STORAGE_KEYS.verifyToken, res.authToken, {
          maxAge: res.expireTime,
        });
        dispatch(setEmail(values.username));
        navigate("/auth/verify-two-factor-authentication");
      } else if (
        res.sessionType === SESSION_TYPE.TWO_FA &&
        res.twoFactorAuth === TWO_FACTOR_AUTH.GOOGLE_AUTH &&
        !res.verified
      ) {
        StorageHelper.setCookie(STORAGE_KEYS.verifyToken, res.authToken, {
          maxAge: res.expireTime,
        });
        navigate("/auth/request-qr-code");
      }
    } else {
      setLoading(false);
    }
  };

  return (
    <div className={styles.authPage}>
      <div className={styles.authContent}>
        <div className={styles.authLogo}>
          <LogoIcon />
        </div>
        <div className={styles.authForm}>
          <LoginForm onSubmit={handleSubmit} loading={loading} />
          <Divider>
            <span style={{ color: "#9499A0" }}>OR</span>
          </Divider>
          <SocialLogin loading={loading} />
          <Space
            direction="horizontal"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: 20,
            }}
          >
            <span>{`${t("label.signUpMessage")} `}</span>
            <Link
              to="/auth/sign-up"
              style={{
                fontWeight: 700,
                pointerEvents: loading ? "none" : "auto",
              }}
            >
              {t("label.signUp")}
            </Link>
          </Space>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <a
            target="_blank"
            href="https://messageclub.com/privacy-policy.html"
            rel="noreferrer"
            style={{ marginRight: 10, fontSize: 14, color: "#1F2A37" }}
          >
            Privacy Policy
          </a>
          <a
            target="_blank"
            href="https://messageclub.com/term-of-service.html"
            rel="noreferrer"
            style={{ fontSize: 14, color: "#1F2A37" }}
          >
            Terms of Service
          </a>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
